import uap from 'ua-parser-js'

export default ({ req, store }) => {
  const ua = uap(req?.headers['user-agent'] || '')
  store.commit('setDeviceInfo', ua)
}
